let config = {};

// apisllk.kjlke.com  正式
// testapisllk.kjlke.com     测试
// productapisllk.kjlke.com  开发
// config.Domain = 'http://apisllk.kjlke.com/v1/admin/';
  config.Domain = process.env.VUE_APP_API_URL + '/v1/admin/';
// if (process.env.NODE_ENV === 'production') {
//     config.Domain = 'http://testapisllk.kjlke.com/v1/admin/';
// } else {
//     config.Domain = 'http://testapisllk.kjlke.com/v1/admin/';
// }
export default config